var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeseriesCirclelefticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2896_3546",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "matrix(-1 0 0 1 20.5488 0.625)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2896_3546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.98649 10.6243L12.549 13.1868L11.3823 14.3743L7.63232 10.6243L11.3823 6.87435L12.549 8.06185L9.98649 10.6243ZM10.549 18.9577C11.7018 18.9577 12.7851 18.7389 13.799 18.3014C14.8129 17.8639 15.6948 17.2702 16.4448 16.5202C17.1948 15.7702 17.7886 14.8882 18.2261 13.8743C18.6636 12.8605 18.8823 11.7771 18.8823 10.6243C18.8823 9.47157 18.6636 8.38824 18.2261 7.37435C17.7886 6.36046 17.1948 5.47852 16.4448 4.72852C15.6948 3.97852 14.8129 3.38477 13.799 2.94727C12.7851 2.50977 11.7018 2.29102 10.549 2.29102C9.39621 2.29102 8.31288 2.50977 7.29899 2.94727C6.2851 3.38477 5.40316 3.97852 4.65316 4.72852C3.90316 5.47852 3.30941 6.36046 2.87191 7.37435C2.43441 8.38824 2.21566 9.47157 2.21566 10.6243C2.21566 11.7771 2.43441 12.8605 2.87191 13.8743C3.30941 14.8882 3.90316 15.7702 4.65316 16.5202C5.40316 17.2702 6.2851 17.8639 7.29899 18.3014C8.31288 18.7389 9.39621 18.9577 10.549 18.9577Z",
    fill: "#7E7E7E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeseriesCirclelefticon);
export default __webpack_public_path__ + "static/media/Timeseries_circlelefticon.79e351d3ff9c068126fd14c396d1914e.svg";
export { ForwardRef as ReactComponent };